import { render, staticRenderFns } from "./ForwardToSupport.vue?vue&type=template&id=9f9321c8&scoped=true"
import script from "./ForwardToSupport.vue?vue&type=script&lang=js"
export * from "./ForwardToSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9321c8",
  null
  
)

export default component.exports